export const getSeason = () => {
  const month = new Date().getMonth();
  if (month > 4 && month < 10) {
    return true; // Summer
  } else {
    return false; // Winter
  }
};
